import { EDIT_ASYNC, SELECT_TOGGLE } from './constants'

const edit = (data) => ({ type: EDIT_ASYNC.INITIATE, payload: { ...data } })
const editCancel = (id) => ({ type: EDIT_ASYNC.CANCEL, payload: { id } })
export const editSuccess = (data) => ({
  type: EDIT_ASYNC.SUCCESS,
  payload: { data },
})
export const editError = (error) => ({ type: EDIT_ASYNC.ERROR, error })

const toggleSelect = (id) => ({ type: SELECT_TOGGLE, payload: { id } })

export default {
  // to props
  edit,
  editCancel,
  toggleSelect,
}
